import React, { useState } from 'react';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import logo from '../../assets/images/logo.jpg';
import {
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
  Collapse,
} from '@mui/material';
import {
  Menu as MenuIcon,
  AccountCircle as AccountIcon,
  Logout as LogoutIcon,
  ExpandLess,
  ExpandMore,
} from '@mui/icons-material';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AddIcon from '@mui/icons-material/Add';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import SummarizeIcon from '@mui/icons-material/Summarize';
import GeneratingTokensIcon from '@mui/icons-material/GeneratingTokens';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import useIsMobile from '../../hooks/useIsMobile';

const drawerWidth = 240;

export default function Layout() {
  const [open, setOpen] = useState(true);
  const [openVans, setOpenVans] = useState(false);
  const [openLoads, setOpenLoads] = useState(false);
  const [openCoupens, setOpenCoupens] = useState(false);
  const [openOrders, setOpenOrders] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleDrawerToggle = () => setOpen(!open);
  const isMobile = useIsMobile();

  const token = JSON.parse(localStorage.getItem('token'));
  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const menuItems = [
    { text: 'Change Password', icon: <AccountIcon />, path: '/settings/change-password' },
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* AppBar */}
      <AppBar
        position="fixed"
        sx={{
          width: { sm: open ? `calc(100% - ${drawerWidth}px)` : '100%' },
          ml: { sm: open ? `${drawerWidth}px` : 0 },
        }}
      >
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={handleDrawerToggle}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Welcome {token.name}
          </Typography>
          <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer
        variant={isMobile ? 'temporary' : 'persistent'}
        open={isMobile ? !open : open}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: isMobile }}
        sx={{
          display: { xs: isMobile ? 'block' : 'none', sm: isMobile ? 'none' : 'block' },
          width: isMobile ? 'auto' : open ? `${drawerWidth}px` : 0,
          flexShrink: 0,
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {/* Logo at the top of the drawer */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Box
            component={Link}
            to="/"
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Box
              component="img"
              src={logo} // Replace with your logo path
              alt="Logo"
              sx={{ maxHeight: 50, maxWidth: '80%',borderColor:'BLUE', }}
            />
          </Box>
        </Box>

        <Divider />

        <List>
          {/* Vans */}
          <ListItem button onClick={() => setOpenVans(!openVans)}>
            <ListItemIcon><AirportShuttleIcon /></ListItemIcon>
            <ListItemText primary="Vans" />
            {openVans ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openVans} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/vans/manage" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><ListAltIcon /></ListItemIcon>
                <ListItemText primary="Manage Vans" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/vans/add" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><AddIcon /></ListItemIcon>
                <ListItemText primary="Add Van" />
              </ListItem>
            </List>
          </Collapse>

          {/* Loads */}
          <ListItem button onClick={() => setOpenLoads(!openLoads)}>
            <ListItemIcon><ScheduleSendIcon /></ListItemIcon>
            <ListItemText primary="Loads" />
            {openLoads ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openLoads} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/loads/manage" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><ListAltIcon /></ListItemIcon>
                <ListItemText primary="Manage Loads" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/loads/add" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><AddIcon /></ListItemIcon>
                <ListItemText primary="Add Load" />
              </ListItem>
            </List>
          </Collapse>

          {/* Orders */}
          <ListItem button onClick={() => setOpenOrders(!openOrders)}>
            <ListItemIcon><SummarizeIcon /></ListItemIcon>
            <ListItemText primary="Orders" />
            {openOrders ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openOrders} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/order/manage" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><ListAltIcon /></ListItemIcon>
                <ListItemText primary="Manage Orders" />
              </ListItem>
            </List>
          </Collapse>

          {/* coupon */}

          <ListItem button onClick={() => setOpenCoupens(!openCoupens)}>
            <ListItemIcon><GeneratingTokensIcon /></ListItemIcon>
            <ListItemText primary="Coupons" />
            {openCoupens ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openCoupens} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/coupons/manage" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><ListAltIcon /></ListItemIcon>
                <ListItemText primary="Manage Coupons" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} component={Link} to="/coupons/add" onClick={isMobile ? handleDrawerToggle : undefined}>
                <ListItemIcon><AddIcon /></ListItemIcon>
                <ListItemText primary="Add Coupon" />
              </ListItem>
            </List>
          </Collapse>

          {/* Static Menu Items */}
          {menuItems.map(({ text, icon, path }) => (
            <ListItem button key={text} component={Link} to={path}>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
          width: '98vw',
          maxWidth: '100%',
          transition: (theme) =>
            theme.transitions.create(['margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          ml: open ? 1 : 0,
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
